const WorkData = [
  {
      worknumber: "img_position project1",
      project_type: "Featured project",
      title: "Sweet Green",
      text: "This is an E-commerce website for fruits and vegetables. It was made responsive using media queries.",
      link: "https://sweet-green.netlify.app/",
      language: "HTML  CSS  Javascript",
  },
  {
      worknumber: "img_position project2",
      project_type: "Featured project",
      title: "To do list",
      text: "A simple to do list app.",
      link: "https://simple-to-dolistapp.netlify.app/",
      language: "React",
  },
  {
      worknumber: "img_position project3",
      project_type: "Featured project",
      title: "Furniture Land",
      text: "Am E-commerce website landing page.",
      link: "https://furnitureland-landingpage.netlify.app/",
      language: "React Bootstrap",
  },
  {
      worknumber: "img_position project4",
      project_type: "Featured project",
      title: "Weather App",
      text: "A Weather forecast website with data fetched from OpenWeatherMap API",
      link: "https://weatherappjc.netlify.app/",
      language: "Html CSS Javascript",
  },
];

export default WorkData;